// // // import React from "react";
// // // import Slider from "react-slick";
// // // import { Link } from "react-router-dom";
// // // import "slick-carousel/slick/slick.css";
// // // import "slick-carousel/slick/slick-theme.css";
// // // import pimg1 from '../../images/partners/partner_logo_1.svg'
// // // import pimg2 from '../../images/partners/partner_logo_2.svg'
// // // import pimg3 from '../../images/partners/partner_logo_3.svg'
// // // import pimg4 from '../../images/partners/partner_logo_4.svg'
// // // import pimg5 from '../../images/partners/partner_logo_5.svg'
// // // import pimg6 from '../../images/partners/partner_logo_6.svg'
// // // import pimg7 from '../../images/partners/partner_logo_5.svg'

// // // const partners = [
// // //     {
// // //         pImg: pimg1,
// // //     },
// // //     {
// // //         pImg: pimg2,
// // //     },
// // //     {
// // //         pImg: pimg3,
// // //     },
// // //     {
// // //         pImg: pimg4,
// // //     },
// // //     {
// // //         pImg: pimg5,
// // //     },
// // //     {
// // //         pImg: pimg6,
// // //     },
// // //     {
// // //         pImg: pimg7,
// // //     },
// // //     {
// // //         pImg: pimg2,
// // //     },
// // // ]

// // // var settings = {
// // //     dots: false,
// // //     infinite: true,
// // //     speed: 5000,
// // //     slidesToShow: 7,
// // //     slidesToScroll: 1,
// // //     autoplay: true,
// // //     autoplaySpeed: 0,
// // //     cssEase: "linear",
// // //     arrows: false,

// // //     responsive: [
// // //         {
// // //             breakpoint: 1700,
// // //             settings: {
// // //                 slidesToShow: 7,
// // //                 slidesToScroll: 1,
// // //             }
// // //         },
// // //         {
// // //             breakpoint: 1199,
// // //             settings: {
// // //                 slidesToShow: 5,
// // //                 slidesToScroll: 1
// // //             }
// // //         },
// // //         {
// // //             breakpoint: 991,
// // //             settings: {
// // //                 slidesToShow: 3,
// // //                 slidesToScroll: 1
// // //             }
// // //         },
// // //         {
// // //             breakpoint: 767,
// // //             settings: {
// // //                 slidesToShow: 2,
// // //                 slidesToScroll: 1
// // //             }
// // //         },
// // //         {
// // //             breakpoint: 600,
// // //             settings: {
// // //                 slidesToShow: 2,
// // //                 slidesToScroll: 1
// // //             }
// // //         },
// // //         {
// // //             breakpoint: 450,
// // //             settings: {
// // //                 slidesToShow: 2,
// // //                 slidesToScroll: 1
// // //             }
// // //         },
// // //         {
// // //             breakpoint: 340,
// // //             settings: {
// // //                 slidesToShow: 2,
// // //                 slidesToScroll: 1
// // //             }
// // //         }
// // //     ]
// // // };



// // // const PartnerSection = (props) => {

// // //     return (
// // //         <section className="partner_section">
// // //             <div className="container-fluid">
// // //                 <div className="ico_heading_block text-center">
// // //                     <h2 className="highlight_title mb-0" data-aos="fade-up" data-aos-duration="600">
// // //                         Our top Partner
// // //                     </h2>
// // //                 </div>
// // //                 <div className="partner_logo_carousel z-2 position-relative" data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
// // //                     <Slider {...settings}>
// // //                         {partners.map((partner, pitem) => (
// // //                             <div className="ico_partner_logo" key={pitem}>
// // //                                 <Link className="logo_wrap" to="/" >
// // //                                 <img src={partner.pImg} alt="Partner Logo"/>
// // //                                     <span className="dot_1"></span>
// // //                                     <span className="dot_2"></span>
// // //                                     <span className="dot_3"></span>
// // //                                     <span className="dot_4"></span>
// // //                                 </Link>
// // //                             </div>
// // //                         ))}
// // //                     </Slider>
// // //                 </div>
// // //             </div>
// // //         </section>
// // //     );
// // // }

// // // export default PartnerSection;

// // import Slider from "react-slick"
// // import { Link } from "react-router-dom"
// // import { useApi } from "../../hooks/useApi"
// // import "slick-carousel/slick/slick.css"
// // import "slick-carousel/slick/slick-theme.css"

// // var settings = {
// //   dots: false,
// //   infinite: true,
// //   speed: 5000,
// //   slidesToShow: 7,
// //   slidesToScroll: 1,
// //   autoplay: true,
// //   autoplaySpeed: 0,
// //   cssEase: "linear",
// //   arrows: false,

// //   responsive: [
// //     {
// //       breakpoint: 1700,
// //       settings: {
// //         slidesToShow: 7,
// //         slidesToScroll: 1,
// //       },
// //     },
// //     {
// //       breakpoint: 1199,
// //       settings: {
// //         slidesToShow: 5,
// //         slidesToScroll: 1,
// //       },
// //     },
// //     {
// //       breakpoint: 991,
// //       settings: {
// //         slidesToShow: 3,
// //         slidesToScroll: 1,
// //       },
// //     },
// //     {
// //       breakpoint: 767,
// //       settings: {
// //         slidesToShow: 2,
// //         slidesToScroll: 1,
// //       },
// //     },
// //     {
// //       breakpoint: 600,
// //       settings: {
// //         slidesToShow: 2,
// //         slidesToScroll: 1,
// //       },
// //     },
// //     {
// //       breakpoint: 450,
// //       settings: {
// //         slidesToShow: 2,
// //         slidesToScroll: 1,
// //       },
// //     },
// //     {
// //       breakpoint: 340,
// //       settings: {
// //         slidesToShow: 2,
// //         slidesToScroll: 1,
// //       },
// //     },
// //   ],
// // }

// // const PartnerSection = (props) => {
// //   const { data: partnersData, loading, error } = useApi("/partners")

// //   if (loading) {
// //     return (
// //       <section className="partner_section">
// //         <div className="container-fluid">
// //           <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
// //             <div className="spinner-border text-primary" role="status">
// //               <span className="sr-only">Loading...</span>
// //             </div>
// //           </div>
// //         </div>
// //       </section>
// //     )
// //   }

// //   if (error || !partnersData || !partnersData.partners) {
// //     return null
// //   }

// //   return (
// //     <section className="partner_section">
// //       <div className="container-fluid">
// //         <div className="ico_heading_block text-center">
// //           <h2 className="highlight_title mb-0" data-aos="fade-up" data-aos-duration="600">
// //             {partnersData.title || "Our top Partner"}
// //           </h2>
// //         </div>
// //         <div
// //           className="partner_logo_carousel z-2 position-relative"
// //           data-aos="fade-up"
// //           data-aos-duration="600"
// //           data-aos-delay="200"
// //         >
// //           <Slider {...settings}>
// //             {partnersData.partners.map((partner, pitem) => (
// //               <div className="ico_partner_logo" key={pitem}>
// //                 <Link className="logo_wrap" to={partner.link || "/"}>
// //                   <img src={partner.logo || "/placeholder.svg"} alt={partner.name || "Partner Logo"} />
// //                   <span className="dot_1"></span>
// //                   <span className="dot_2"></span>
// //                   <span className="dot_3"></span>
// //                   <span className="dot_4"></span>
// //                 </Link>
// //               </div>
// //             ))}
// //           </Slider>
// //         </div>
// //       </div>
// //     </section>
// //   )
// // }

// // export default PartnerSection

// import Slider from "react-slick"
// import { Link } from "react-router-dom"
// import { useApi } from "../../hooks/useApi"
// import "slick-carousel/slick/slick.css"
// import "slick-carousel/slick/slick-theme.css"
// import pimg1 from "../../images/partners/partner_logo_1.svg"
// import pimg2 from "../../images/partners/partner_logo_2.svg"
// import pimg3 from "../../images/partners/partner_logo_3.svg"
// import pimg4 from "../../images/partners/partner_logo_4.svg"
// import pimg5 from "../../images/partners/partner_logo_5.svg"
// import pimg6 from "../../images/partners/partner_logo_6.svg"
// import pimg7 from "../../images/partners/partner_logo_5.svg"

// const defaultPartners = [
//   { pImg: pimg1 },
//   { pImg: pimg2 },
//   { pImg: pimg3 },
//   { pImg: pimg4 },
//   { pImg: pimg5 },
//   { pImg: pimg6 },
//   { pImg: pimg7 },
//   { pImg: pimg2 },
// ]

// var settings = {
//   dots: false,
//   infinite: true,
//   speed: 5000,
//   slidesToShow: 7,
//   slidesToScroll: 1,
//   autoplay: true,
//   autoplaySpeed: 0,
//   cssEase: "linear",
//   arrows: false,

//   responsive: [
//     {
//       breakpoint: 1700,
//       settings: {
//         slidesToShow: 7,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 1199,
//       settings: {
//         slidesToShow: 5,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 991,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 450,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       },
//     },
//     {
//       breakpoint: 340,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 1,
//       },
//     },
//   ],
// }

// const PartnerSection = (props) => {
//   const { data: partnersData, loading, error } = useApi("/partners")

//   // Use API data if available, otherwise use default
//   const partners =
//     partnersData && Array.isArray(partnersData) && partnersData.length > 0
//       ? partnersData.map((partner) => ({ pImg: partner.logo || pimg1 }))
//       : defaultPartners

//   if (loading) {
//     console.log("Partners section loading...")
//   }

//   if (error) {
//     console.error("Partners API error:", error)
//   }

//   return (
//     <section className="partner_section">
//       <div className="container-fluid">
//         <div className="ico_heading_block text-center">
//           <h2 className="highlight_title mb-0" data-aos="fade-up" data-aos-duration="600">
//             Our top Partner
//           </h2>
//         </div>
//         <div
//           className="partner_logo_carousel z-2 position-relative"
//           data-aos="fade-up"
//           data-aos-duration="600"
//           data-aos-delay="200"
//         >
//           <Slider {...settings}>
//             {partners.map((partner, pitem) => (
//               <div className="ico_partner_logo" key={pitem}>
//                 <Link className="logo_wrap" to="/">
//                   <img src={partner.pImg || "/placeholder.svg"} alt="Partner Logo" />
//                   <span className="dot_1"></span>
//                   <span className="dot_2"></span>
//                   <span className="dot_3"></span>
//                   <span className="dot_4"></span>
//                 </Link>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </div>
//     </section>
//   )
// }

// export default PartnerSection

import Slider from "react-slick"
import { useApi } from "../../hooks/useApi"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

import pimg1 from "../../images/partners/partner_logo_1.svg"
import pimg2 from "../../images/partners/partner_logo_2.svg"
import pimg3 from "../../images/partners/partner_logo_3.svg"
import pimg4 from "../../images/partners/partner_logo_4.svg"
import pimg5 from "../../images/partners/partner_logo_5.svg"
import pimg6 from "../../images/partners/partner_logo_6.svg"
import pimg7 from "../../images/partners/partner_logo_5.svg"

const defaultPartners = [
  { pImg: pimg1 },
  { pImg: pimg2 },
  { pImg: pimg3 },
  { pImg: pimg4 },
  { pImg: pimg5 },
  { pImg: pimg6 },
  { pImg: pimg7 },
  { pImg: pimg2 },
]

const settings = {
  dots: false,
  infinite: true,
  speed: 5000,
  slidesToShow: 7,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,
  responsive: [
    {
      breakpoint: 1700,
      settings: { slidesToShow: 7 },
    },
    {
      breakpoint: 1199,
      settings: { slidesToShow: 5 },
    },
    {
      breakpoint: 991,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 767,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 450,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 340,
      settings: { slidesToShow: 2 },
    },
  ],
}

const PartnerSection = () => {
  const { data: partnersData, loading, error } = useApi("/partners")

  const partners =
    partnersData &&
    partnersData.success &&
    Array.isArray(partnersData.data) &&
    partnersData.data.length > 0
      ? partnersData.data.map((partner) => ({
          pImg: partner.logo || pimg1,
          name: partner.name || "Partner",
          website: partner.website || "#",
        }))
      : defaultPartners.map((partner) => ({
          pImg: partner.pImg,
          name: "Partner",
          website: "#",
        }))

  if (loading) console.log("Partners section loading...")
  if (error) console.error("Partners API error:", error)

  return (
    <section className="partner_section">
      <div className="container-fluid">
        <div className="ico_heading_block text-center">
          <h2 className="highlight_title mb-0" data-aos="fade-up" data-aos-duration="600">
            Our Top Partners
          </h2>
        </div>
        <div
          className="partner_logo_carousel z-2 position-relative"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="200"
        >
          <Slider {...settings}>
            {partners.map((partner, index) => (
              <div className="ico_partner_logo" key={index}>
                <a
                  className="logo_wrap"
                  href={partner.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={partner.pImg || "/placeholder.svg"}
                    alt={`${partner.name} Logo`}
                  />
                  <span className="dot_1"></span>
                  <span className="dot_2"></span>
                  <span className="dot_3"></span>
                  <span className="dot_4"></span>
                </a>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  )
}

export default PartnerSection

